import axios, {type AxiosInstance} from 'axios';
import {getAccessToken} from '../security/keycloak';

/**
 * @returns an axios instance that sets the appropriate Authorization header.
 * Refreshes the access token when necessary.
 */
export async function myAxios(): Promise<AxiosInstance> {
  const instance = axios.create();
  const token = await getAccessToken();
  if (token) {
    instance.defaults.headers.common.Authorization = `Bearer ${token}`;
  }
  return instance;
}
